import mergeDeep from "../utils/global";
import * as types from "../actions/actionTypes";
/*
config: {
    "id": "PREPROCESSING_ID",
    "info": "description of the processing",
    directory: "output folder path",
    main_document: {
      "id": "MAIN",
      "mandatory": "yes",
      "regexp": "/^START/ or /END$/ or /CONTENT/ or empty",
      "info": "description of the main document"
    },
    attachment_list: [
      {
        "id": "ACH_CATEGORY_NAME",
        "mode": "linked|free",
        "mandatory": "yes|no",
        "regexp": "/^START/ or /END$/ or /CONTENT/ or empty",
        "info": "description of the attachment",
        "link_info": "description if mode is linked"
      }
    ],
    insert_list: [
      {
        "id": "INS_CATEGORY_NAME",
        "mandatory": "yes|no",
        "regexp": "/^START/ or /END$/ or /CONTENT/ or empty",
        "info": "description of the insert"
      }
    ]
  }
*/

/*
configMain: {
    id: "MAIN",
    mandatory: "yes",
    info: "description of the main document"
  },
  configAttachmentList: [
    {
      id: "ACH_CATEGORY_NAME",
      mandatory: "no",
      info: "description of the attachment"
    },
    {
      id: "ACH_CATEGORY_NAME2",
      mandatory: "yes",
      info: "description of the attachment 52"
    },
    {
      id: "ACH_CATEGORY_NAME3",
      mandatory: "yes",
      info: "description of the attachment 52"
    }
  ],
  configInsertList: [
    {
      id: "INS_CATEGORY_NAME",
      mandatory: "yes",
      info: "description of the insert1"
    },
    {
      id: "INS_CATEGORY_NAME2",
      mandatory: "yes",
      info: "description of the insert2"
    },
    {
      id: "INS_CATEGORY_NAME3",
      mandatory: "no",
      info: "description of the insert3"
    },
    {
      id: "INS_CATEGORY_NAME4",
      mandatory: "yes",
      info: "description of the insert4"
    }
  ],
  */
const initialState = {
  running: false,
  progress: 0,
  fileName: "",

  configLoaded: false,
  configMain: {},
  configAttachmentList: [],
  configInsertList: [],

  mainUpload: null,
  attachmentUploads: [],
  insertUploads: []
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPLOAD_START_REQUEST:
      return {
        ...state,
        running: true,
        progress: 0,
        fileName: action.fileName,
        mainUpload: null,
        attachmentUploads: [],
        insertUploads: []
      };
    case types.UPLOAD_END_REQUEST:
      return {
        ...state,
        running: false,
        progress: 0,
        fileName: "",
        mainUpload: null,
        attachmentUploads: [],
        insertUploads: []
      };
    case types.UPLOAD_UPDATE_PROGRESS:
      return { ...state, running: true, progress: action.progress };
    case types.APP_FLUSH_DATAS:
      return initialState;
    case types.ADD_MAIN_UPLOAD_FILE: {
      return { ...state, mainUpload: action.file };
    }
    case types.REMOVE_MAIN_UPLOAD_FILE: {
      return { ...state, mainUpload: null };
    }
    case types.ADD_ATTACHMENT_UPLOAD_FILE: {
      let newAttState = [...state.attachmentUploads];
      mergeDeep(newAttState, state.attachmentUploads);

      const newUpload = {
        fieldId: action.fieldId,
        file: action.file
      };
      let attIdFound = false;
      for (let i = 0; i < newAttState.length; i++) {
        if (newAttState[i].fieldId === action.fieldId) {
          newAttState[i] = newUpload;
          attIdFound = true;
          break;
        }
      }

      if (!attIdFound) {
        newAttState.push(newUpload);
      }

      return { ...state, attachmentUploads: newAttState };
    }
    case types.REMOVE_ATTACHMENT_UPLOAD_FILE: {
      let newUploads = [...state.attachmentUploads];
      let indexToRemove = -1;
      for (let i = 0; i < newUploads.length; i++) {
        if (newUploads[i].fiedId === action.fileId) {
          indexToRemove = i;
          break;
        }
      }
      if (indexToRemove > -1) newUploads.splice(indexToRemove, 1);
      return {
        ...state,
        attachmentUploads: newUploads
      };
    }
    case types.SET_ATTACHMENT_MANDATORY_FILLED: {
      return state;
    }
    case types.ADD_INSERT_UPLOAD_FILE: {
      const newUpload = {
        fieldId: action.fieldId,
        file: action.file
      };
      let newUploads = [...state.insertUploads.uploads, newUpload];
      return {
        ...state,
        insertUploads: {
          ...state.insertUploads,
          mandatoryFilled: action.mandatoryFilled,
          uploads: newUploads
        }
      };
    }
    case types.REMOVE_INSERT_UPLOAD_FILE: {
      let newUploads = [...state.insertUploads];
      let indexToRemove = -1;
      for (let i = 0; i < newUploads.length; i++) {
        if (newUploads[i].fiedId === action.fileId) {
          indexToRemove = i;
          break;
        }
      }
      if (indexToRemove > -1) newUploads.splice(indexToRemove, 1);
      return {
        ...state,
        insertUploads: {
          ...state.insertUploads,
          mandatoryFilled: action.mandatoryFilled,
          uploads: newUploads
        }
      };
    }
    case types.SET_INSERT_MANDATORY_FILLED: {
      return state;
    }
    case types.GET_CONFIGURATION_JSON_START: {
      return {
        ...state,
        configMain: {},
        configAttachmentList: [],
        configInsertList: [],
        configLoaded: false,
        mainUpload: null,
        attachmentUploads: [],
        insertUploads: []
      };
    }
    case types.GET_CONFIGURATION_JSON_END: {
      const configMain = action.configuration.main_document
        ? action.configuration.main_document
        : {};
      const configAttachmentList = action.configuration.attachment_list
        ? action.configuration.attachment_list
        : [];
      const configInsertList = action.configuration.insert
        ? action.configuration.insert
        : [];

      let attachmentUploads = [];
      let insertUploads = [];
      return {
        ...state,
        configLoaded: true,
        configMain,
        configAttachmentList,
        configInsertList,
        attachmentUploads,
        insertUploads
      };
    }
    case types.GET_CONFIGURATION_JSON_END_ERROR: {
      return {
        ...state,
        configMain: {},
        configAttachmentList: [],
        configInsertList: [],
        configLoaded: true,
        mainUpload: null,
        attachmentUploads: [],
        insertUploads: []
      };
    }
    default:
      return state;
  }
};

export default errorReducer;



// WEBPACK FOOTER //
// ./src/reducers/uploadReducer.js